import { TbArrowUpRight, TbUsers } from "react-icons/tb";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getDashboardRecords } from "../../api/admin";
import { formatCurrency } from "../../utils/utils";
import Loading from "../shared/Loading";

export default function Dashboard(props) {
  const { data, isLoading } = useQuery("dashboard", getDashboardRecords);

  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    if (data) {
      const totals = (data?.cryptoBalances || []).reduce(
        (acc, { currency, total }) => {
          acc[`user${currency}total`] = total;
          return acc;
        },
        {},
      );

      console.log(totals, "RESULT");

      const result = Object.entries(totals).map(([key, value]) => ({
        key,
        amount: value,
        title:
          key
            .replace(/^user/, "")
            .replace(/total$/, "")
            .toUpperCase() + " Total",
        type: 12,
      }));
      setDashboardData(
        [
          // {
          //   key: "total_naira_transactions",
          //   amount: formatCurrency(data?.nairaTransactions || 0),
          //   title: "Total Naira Transactions",

          //   type: 1,
          // },
          {
            key: "crypto_transactions",
            amount: formatCurrency(data?.cryptoTransactions || 0),
            title: "Crypto Transactions",

            type: 1,
          },
          {
            key: "usersFiatBalance",
            amount: formatCurrency(data?.usersFiatBalance || 0),
            title: "Total User's Fiat Balance",

            type: 1,
          },
          {
            key: "gift_card_transactions",
            amount: formatCurrency(data?.giftcardTransactions || 0),
            title: "Gift Card Transactions",

            type: 1,
          },
          {
            key: "deposits",
            amount: formatCurrency(data?.deposits || 0),
            title: "Deposits",

            type: 1,
          },
          {
            key: "withdrawals",
            amount: formatCurrency(data?.withdrawals || 0),
            title: "Withdrawals",

            type: 1,
          },
          // {
          //   key: "shipments",
          //   amount: formatCurrency(data?.productSold || 0),
          //   title: "Shipments",

          //   type: 1,
          // },
          {
            key: "customers",
            amount: Number(data?.totalCustomers || 0),
            title: "Total Customers",

            type: 2,
          },
          {
            key: "referrals",
            amount: Number(data?.totalReferrals || 0),
            title: "Total Referrals",

            type: 2,
          },
        ].concat(result),
      );
    }
  }, [data]);

  return (
    <div className="w-full h-full pt-5 px-5 pb-40 space-y-6">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="flex flex-col gap-5">
            <div className="font-dmsans font-bold text-[22px] text-[#070E05]">
              Dashboard
            </div>
            <div
              className="grid gap-4"
              style={{
                gridTemplateColumns: "repeat(auto-fit, minmax(32.3%, 0fr))",
              }}
            >
              {dashboardData.map((v, k) => {
                return <DashboardItem key={k} data={v} />;
              })}
            </div>
          </div>
          {/* <div className="flex flex-col gap-3 bg-white rounded-lg p-5">
            <div className="tracking-[-0.4 px] font-dmsans font-bold text-[18px] text-[#070E05]">
              Latest Orders
            </div>
           <OrderTable data={orderData} />
            <div className="flex flex-col items-end mt-4 mb-3">
              <Link
                to={"/orders"}
                className="font-dmsans font-bold text-[#4A4DE6] tracking-[-0.3 px] text-[14px] flex items-center gap-1"
              >
                <span>View all orders</span>
                <BsChevronRight className="text-[11px]" />
              </Link>
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}

function DashboardItem(props) {
  return (
    <div className="w-full bg-white border-[#E6E7E9] font-dmsans border-[1px] rounded-[5px] px-[28px] py-[18px]">
      {props.data.type == 1 ? (
        <div className="flex flex-col gap-3">
          <div className="text-[20px] text-[#14142B]">{props.data.amount}</div>
          <div className="text-[14px] text-[#00000080]">{props.data.title}</div>
        </div>
      ) : (
        <div className="flex justify-between items-center h-full ">
          <div className="flex flex-col gap-2">
            <div className="text-[20px] text-[#14142B]">
              {props.data.amount}
            </div>
            <div className="text-[14px] text-[#00000080]">
              {props.data.title}
            </div>
          </div>
          <div className="bg-[#EDEEF6] rounded-full p-4 text-[25px] text-[#035AA6]">
            <TbUsers />
          </div>
        </div>
      )}
    </div>
  );
}
